import { Component, ViewChild, AfterViewInit } from '@angular/core';
import { SmrsRatePopupComponent } from '../smrs-rate-popup/smrs-rate-popup.component';

@Component({
  selector: 'app-smrs-rate-management',
  standalone: true,
  imports: [SmrsRatePopupComponent],
  templateUrl: './smrs-rate-management.component.html',
  styleUrl: './smrs-rate-management.component.css'
})
export class SmrsRateManagementComponent implements AfterViewInit {
  @ViewChild('ratePopup') ratePopup!: SmrsRatePopupComponent;
  periods: string[] = [];

  constructor() {
    this.generatePeriods();
  }

  generatePeriods() {
    this.periods = [];
    const startDate = new Date(2024, 0, 1);
    const currentDate = new Date();
    const tempDate = new Date(startDate);

    while (tempDate <= currentDate) {
      const year = tempDate.getFullYear();
      const month = (tempDate.getMonth() + 1).toString().padStart(2, '0');
      this.periods.push(`${year}/${month}`);
      tempDate.setMonth(tempDate.getMonth() + 1);
    }
    this.periods.reverse();
  }

  ngAfterViewInit() {
    // Automatically initialize the shared component in inline mode
    setTimeout(() => {
      const initialPeriod = this.periods.length > 0 ? this.periods[0] : '';
      this.ratePopup.open(initialPeriod);
    });
  }
}
